import React, { useMemo } from 'react'

export function WithSidebar<P extends object>(WrappedComponent: React.ComponentType<any>, categoriesItem: any) {
  // 侧边栏分类元数据
  const sidebarCategoriesMetadata = useMemo(() => {
    let categoriesMetadata = null
    try {
      categoriesMetadata = JSON.parse(categoriesItem?.components?.[0]?.sidebar?.categoriesMetadata || '{}')
    } catch (error) {
      console.log('categoriesMetadata Parse error', error)
    }
    return categoriesMetadata
  }, [categoriesItem])

  // 侧边栏系列元数据
  const seriesMetadata = useMemo(() => {
    let seriesMetadata = null
    try {
      seriesMetadata = JSON.parse(categoriesItem?.components?.[0]?.sidebar?.seriesMetadata || '[]')
    } catch (error) {
      console.log('seriesMetadata Parse error', error)
    }
    return seriesMetadata
  }, [categoriesItem])

  const withSidebarDropdown = React.forwardRef<any, P>((props, ref) => {
    return (
      <WrappedComponent
        {...(props as unknown as P)}
        ref={ref}
        seriesMetadata={seriesMetadata}
        sidebarCategoriesMetadata={sidebarCategoriesMetadata}
      />
    )
  })

  withSidebarDropdown.displayName = WrappedComponent.displayName || WrappedComponent.name || 'WithSidebarDropdown'
  return withSidebarDropdown
}

export function WithSupports<P extends object>(
  WrappedComponent: React.ComponentType<any>,
  { categoriesItem, currentNavItemRef }: { categoriesItem: any; currentNavItemRef?: any; onMouseLeave?: () => void }
) {
  const supportsMetadata = useMemo(() => {
    return categoriesItem?.components?.[0]?.supports
  }, [categoriesItem])

  const supportsDropdown = React.forwardRef<any, P>((props, ref) => {
    return (
      <WrappedComponent
        {...(props as unknown as P)}
        supportsMetadata={supportsMetadata}
        currentNavItemRef={currentNavItemRef}
        ref={ref}
      />
    )
  })

  supportsDropdown.displayName = WrappedComponent.displayName || WrappedComponent.name || 'WithSupportsDropdown'
  return supportsDropdown
}

export function WithMulticol<P extends object>(WrappedComponent: React.ComponentType<any>, categoriesItem: any) {
  const showStatsBanner = categoriesItem?.components?.[0]?.showStatsBanner
  const statsBannerData = categoriesItem?.components?.[0]?.statsBanner?.[0]
  const multicolMetadata = useMemo(() => {
    try {
      return JSON.parse(categoriesItem?.components?.[0]?.multicol?.multicolMetadata || '{}')
    } catch (error) {
      console.log('multicolMetadata Parse error', error)
    }
    return null
  }, [categoriesItem])
  const multicolDropdown = React.forwardRef<any, P>((props, ref) => {
    return (
      <WrappedComponent
        {...(props as unknown as P)}
        ref={ref}
        multicolMetadata={multicolMetadata}
        showStatsBanner={showStatsBanner}
        statsBannerData={statsBannerData}
      />
    )
  })

  multicolDropdown.displayName = WrappedComponent.displayName || WrappedComponent.name || 'WithMulticolDropdown'
  return multicolDropdown
}

export function WithResource<P extends object>(WrappedComponent: React.ComponentType<any>, categoriesItem: any) {
  // 资源位分类元数据
  const resourceCategoriesMetadata = useMemo(() => {
    let categoriesMetadata = null
    try {
      categoriesMetadata = JSON.parse(categoriesItem?.components?.[0]?.resource?.categoriesMetadata || '{}')
    } catch (error) {
      console.log('resourceCategoriesMetadata Parse error', error)
    }
    return categoriesMetadata
  }, [categoriesItem])

  // 资源位元数据
  const resourcesMetadata = useMemo(() => {
    let resourcesMetadata = null
    try {
      resourcesMetadata = JSON.parse(categoriesItem?.components?.[0]?.resource?.resourceMetadata || '[]')
    } catch (error) {
      console.log('resourcesMetadata Parse error', error)
    }
    return resourcesMetadata
  }, [categoriesItem])

  const withResourceDropdown = React.forwardRef<any, P>((props, ref) => {
    return (
      <WrappedComponent
        {...(props as unknown as P)}
        ref={ref}
        resourcesMetadata={resourcesMetadata}
        resourceCategoriesMetadata={resourceCategoriesMetadata}
      />
    )
  })

  withResourceDropdown.displayName = WrappedComponent.displayName || WrappedComponent.name || 'WithResourceDropdown'
  return withResourceDropdown
}

export function WithGroupCategory(categories: any) {
  if (!categories) return [[]]
  return Object.values(
    categories?.reduce((acc: any, item: any) => {
      if (!acc[item.group]) {
        acc[item.group] = []
      }
      acc[item.group].push(item)
      return acc
    }, {})
  )
}
